import React from 'react';
import { NavLink } from 'react-router-dom';

class Navigation extends React.Component {

    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/masonary.js');

    };

    render() {
        return (
            <>
                <div className={(this.props.bgcolor !== '') ? `header-nav navbar-collapse collapse ${this.props.bgcolor}` : 'header-nav navbar-collapse collapse'}>
                    <ul className="nav navbar-nav">
                        <li className="active">
                            <NavLink to={""}>Acasă</NavLink>

                        </li>
                        <li>
                        <NavLink to={"/about"}>Despre Noi</NavLink>
                        </li>
                        <li>
                        <NavLink to={"/services"}>Servicii</NavLink>
                        </li>
                        <li>
                        <NavLink to={"/services"}>Porftofoliu</NavLink>
                        </li>
                        <li>
                        <NavLink to={"/contactus"}>Contact</NavLink>

                        </li>


                    </ul>
                </div>
            </>
        );
    };
};

export default Navigation;